import React from "react";

const PageTitle = ({ title, buttons }) => {
    return (
        <div className="flex flex-col items-start space-y-3 lg:flex-row lg:space-y-0 lg:justify-between lg:items-center">
            <h2 className="font-bold text-3xl text-gray-800 leading-tight">
                {title}
            </h2>
            <div className="block w-full space-x-0 space-y-3 sm:w-auto sm:inline sm:space-x-3 sm:space-y-0">
                {buttons?.map(button => button)}
            </div>
        </div>
    );
};

export default PageTitle;
